import ExecutiveOfficesPage from "./pages/ExecutiveOfficesPage";
import ExecutiveOfficeDetailsPage from "./pages/ExecutiveOfficeDetailsPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const executiveOfficeRoutes = [
  {
    path: "/executive-offices",
    element: <ExecutiveOfficesPage />,
    perms: ["executive_office.access"],
  },
  {
    path: "/executive-offices/:id",
    element: <ExecutiveOfficeDetailsPage />,
    perms: ["executive_office.access"],
  },
];
